import React from "react";

import SideSpacing from '../HOC/sidespacing';
import Title from './title';
import Block from './block';

const TextFullPage = props => {

        const blockElementsArray = [];
        for ( let key in props.content ) {
            blockElementsArray.push( {
                id: key,
                config: props.content[key]
            } );
        }

        let block = blockElementsArray.map( blockElement => (
            <Block
                key={blockElement.id}
                blockh2={blockElement.config.head}
                blockp={blockElement.config.body}/>
        ) );

        return (
            <div
            id="background"
            className="flex flex-col w-full items-end min-h-screen mr-6 md:flex-row md:w-auto">
        
                <SideSpacing />

                <div className="flex flex-col flex-1 items-end justify-end w-full mst msb overflow-hidden
                md:mt-0 md:pl-6 md:ml-6">

                    <div className="w-full mst pst md:hidden"/>
                    
                    <Title title={props.title}/>
        
                    {block}

                </div>
        
                <SideSpacing />
        
            </div>

        );
    };

export default TextFullPage;


// WEBPACK FOOTER //
// ./src/components/TextFullPage/textfullpage.js